module.exports = __webpack_public_path__ + "img/web1.9331f972.svg";